import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";

import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Badge,
  IconButton,
  Popover,
  FormControl,
  InputLabel,
  FormHelperText,
  MenuItem,
  Select,
  ButtonGroup,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Menu,
  Chip,
  useMediaQuery,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Store,
  SupervisedUserCircle,
  ArrowForwardIos,
  AssistantPhoto,
  Close,
  CheckCircle,
  Block,
  Edit,
  Delete,
  Folder,
  Description,
  FolderOpen,
  CreateNewFolder,
  Assignment,
  Attachment,
  GetApp,
  Unarchive,
  ArrowBack,
  Label,
  Search,
  MoreVert,
  AttachMoney,
  CallMade,
  CalendarViewDay,
  ArrowDropDown,
  HighlightOff,
  CheckBox,
  MenuOpen
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { Skeleton, Pagination, Autocomplete } from "@material-ui/lab";
import MUIDataTable from "mui-datatables";

import { makeStyles, useTheme } from "@material-ui/styles";

import Dropzone from "react-dropzone";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
  Permissions,
} from "../../../utils/web_config";

import Empty from "../../../assets/svg/empty.svg";

import { useSnackbar } from "notistack";

import { useOrganizations } from "../hooks/use_hooks";

const axios = require("axios");
var FormData = require("form-data");
var fs = require("fs");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    borderRadius: 15,
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  card: {
    borderRadius: 15,
    padding: 5,
  },
}));

function Inventory(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  const orgs = useOrganizations();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [menuOpen, setMenuOpen] = useState(null);

  const [anchorEl, setAnchorEl] = useState({ anchor: null, menu: 0,menu_name:"STOCK IN" });

  const [allItems, setAllItems] = useState({
    loading: false,
    saving: false,
    status: "Loading all items...",
    toggling: false,
    data: [],
  });
  const [stocks, setStocks] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [allItemTypes, setAllItemTypes] = useState({
    loading: false,
    saving: false,
    open: false,
    data: ["DEVICE", "POS", "VALIDATOR", "KIOSK", "CARD", "PROMOTION_MATERIAL", "OFFICE_FURNITURE", "SPARE_PART"],
  });

  const [stockItems, setStockItems] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
    newData: [],
  });

  const [distribution, setDistribution] = useState({
    loading: false,
    saving: false,
    data: [],
  });

  const [searchMode, setSearchMode] = useState(false);

  const [stockOrganization, setOrganization] = useState({
    value: {},
    error: "",
  });

  const [orderOrganization, setOrganization2] = useState({
    value: {},
    error: "",
  });

  const [stockItem, setItem] = useState({ value: "", error: "" });

  /////////////
  const [id,setId]=useState({value:0,error:""});
  const [itemName, setName] = useState({ value: "", error: "" });
  const [itemDescription, setDescription] = useState({ value: "", error: "" });
  const [itemType, setType] = useState({ value: "", error: "" });
  const [parentCategory,setParentCategory]=useState({value:"",error:""});
  const [outOfStockFlag,setOutOfStockFlag]=useState({value:"",error:""});



  useEffect(() => {
    const data = new AdminService().accountData;
    setAccountData(data);

    getAllItems(data.token);

    get_supply_items(data.token);

    get_organization(data.token);

  }, []);

  //////

  /////////////////////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_name")}
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };

  const onDescriptionChange = (event) => {
    if (event.target.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_price")}
          </Translate>
        ),
      });
    } else {
      setDescription({ value: event.target.value, error: "" });
    }
  };

  const onTypeChange = (event) => {
    if (event.target.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_type")}
          </Translate>
        ),
      });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };

  const onCategoryChange=(event)=>{
        setParentCategory({ value: event.target.value, error: "" });  
  }



  ///////////////////////////////////////

  const [action,setAction]=useState("create");
  const onCreateItemClick = () => {
    if (itemType.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_type")}
          </Translate>
        ),
      });
    } else if (itemName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_name")}
          </Translate>
        ),
      });
    } else if (itemDescription.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.category_description")}
          </Translate>
        ),
      });
    } else if(outOfStockFlag.value==0){
      setOutOfStockFlag({value:"",error:"Enter out of stock flag"});
    }else {
      createItem();
    }
  };

  //////////////////////////  supply items /////////////////////


  const [supplyItems, setSupplyItems] = useState({
    loading: false,
    saving: false,
    open:false,
    open_two:false,
    status: "Loading all supply items...",
    toggling: false,
    data: [],
  });

  const columns = [
    {
      name: "id",
      label: "Item id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "supplier_name",
      label: "Supplier Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "starting_serial_number",
      label: "Start serial number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ending_serial_number",
      label: "End serial number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "tag_number",
      label: "Tag Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "item_type",
      label: "Catgeory Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Catgeory Name",
      options: {
        filter: true,
        sort: true,
        display:false
      },
    },
    {
      name: "quantity",
      label: "Quantity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "done_at",
      label: "Done At",
      options: {
        filter: true,
        sort: true,
      },
    }
  ];


  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search item...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: allItems.status,
      },
    }
    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    // <Box mr={2}>
    //  <IconButton onClick={()=>{ 
    //      setAction("update");
    //      setDescription({value:displayData[selectedRows?.data[0]?.index][3],error:""})
    //      setName({value:displayData[selectedRows?.data[0]?.index][1],error:""});
    //      setId({value:displayData[selectedRows?.data[0]?.index][0],error:""});
    //      setType({value:displayData[selectedRows?.data[0]?.index][2],error:""});
    //      setParentCategory({value:displayData[selectedRows?.data[0]?.index][4],error:""});

    //      setAllItems({ ...allItems, open: true });
    //      console.log("selected data",displayData[selectedRows?.data[0]?.index])
    //      }} color="primary" aria-label="Edit Item Category" component="span">
    //    <Edit/>
    //  </IconButton>
    //  <IconButton onClick={()=>{}} color="secondary" aria-label="Delete Item Category" component="span">
    //    <Delete/>
    //  </IconButton>
    //  </Box>
    // //   <></>
    // ),
  };



  ////////// fetch supply items ////////////


  const get_supply_items=(token)=>{
    const itemsInstance = axios.create(new AdminService().getHeaders(token));

    setSupplyItems({ ...supplyItems, loading: true });

    console.log("getting allItems .....");

    itemsInstance
      .get(new ReportingService().GET_SUPPLY_ITEM)
      .then(function (response) {
        setSupplyItems({ ...supplyItems, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setSupplyItems({ ...supplyItems, status: "No supply items available" });
        } else {
            d.data.map((o)=>{
                if(o.item_category!=null){
                    o.item_type= o.item_category.item_type
                    o.name=o.item_category.name
                }else{
                    o.item_category=null
                }
            
            })
            setSupplyItems({
            ...supplyItems,
            data: d.data,
          });
        }
      })
      .catch(function (error) {
        setSupplyItems({ ...supplyItems, loading: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        setSupplyItems({ ...supplyItems, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  }
  //////// notify ////////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };



  ///////// supply item ///////////////




  const [itemCategoryId,setItemCategoryId]=useState({value:0,error:""});
  const [supplierName,setSupplierName]=useState({value:"",error:""});
  const [uid,setUid]=useState({value:"",error:""});
  const [uniqueIdentifier,setUniqueIdentifier]=useState({value:"",error:""});
  const [quantity,setQuantity]=useState({value:0,error:""});


  const [uniqueIdentifiers,setUniqueIdentifiers]=useState([]);


  const supply_item=()=>{

    if(itemCategoryId.value==0){
      setItemCategoryId({value:0,error:"Select category"});
    }else if(quantity.value==0){
      setQuantity({value:0,error:"Enter the quantity"});
    }else if(supplierName.value==""){
      setSupplierName({value:"",error:"Empty supplier name"});
    }else if(uniqueIdentifiers.length==0){
      setUid({value:"",error:"At one unique identifier"});
    }else{
      record_supply_Item();
    }

  }

  const record_supply_Item = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setSupplyItems({ ...supplyItems, saving: true });

    let data={
      item_category_id: itemCategoryId.value,
      quantity:quantity.value,
      supplier_name: supplierName.value,
      unique_identifiers:uniqueIdentifiers
    };



    console.log("Supplying multiple item .....");

    createInstance
      .post(new ReportingService().SUPPLY_MULTIPLE_ITEMS, data)
      .then(function (response) {

        console.log("response",response.data);
        
        setSupplyItems({ ...supplyItems, saving: false , open:false});
        
        var d = response.data;

          if(d.data.item_category!=null){
              d.data.item_type= d.data.item_category.item_type
              d.data.name=d.data.item_category.name
          }else{
              d.data.item_category=null
          }
      
        // var itms = supplyItems.data;
        
        // itms.unshift(d.data);
        
        // setSupplyItems({...supplyItems,data: itms,open: false,});
        

      setItemCategoryId({value:0,error:""});
      setSupplierName({value:"",error:""});
      setUid({value:"",error:""});
      setUniqueIdentifier({value:"",error:""});
      setUniqueIdentifiers([]);
      setQuantity({value:0,error:""});

      get_supply_items(accountData.token);

      notify("success", response.data.message);

      })
      .catch(function (error) {
        setSupplyItems({ ...supplyItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


  /////////////////    supply cards in batches////////////////////
const [serialNumber,setSerialNumber]=useState({value:"",error:""});
const [serialNumbers,setSerialNumbers]=useState([]);
const [endingSerialNumber,setEndingSerialNumber]=useState({value:"",error:""});
const [startingSerialNumber,setStartingSerialNumber]=useState({value:"",error:""});
const [uids,setUids]=useState([]);


  const supply_item_card=()=>{

    // if(serialNumbers.length==0){
    //   notify("error", "Empty serial number detected");
    // }else
    //  if(uids.length==0){
    //   notify("error", "Empty Unique indentifiers");
    // }else 
    if(startingSerialNumber.value==""){
      setStartingSerialNumber({value:"",error:"Empty starting serial number"});
    }else if(endingSerialNumber.value==""){
      setEndingSerialNumber({value:"",error:"Empty ending serial number"});
    }else if(supplierName.value==""){
      setSupplierName({value:"",error:"Empty supplier name"});
    }else{
      record_supply_item_card();
    }

  }


  const record_supply_item_card=()=>{

    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setSupplyItems({ ...supplyItems, saving: true });

    let data={
      ending_serial_number: endingSerialNumber.value,
      item_category: itemCategoryId.value,
      serial_numbers:serialNumbers,
      starting_serial_number: startingSerialNumber.value,
      supplier_name: supplierName.value,
      uids: uids
    };

    



    console.log("Supplying multiple cards .....");

    createInstance
      .post(new ReportingService().SUPPLY_MULTIPLE_CARDS, data)
      .then(function (response) {

        console.log("response",response.data);
        
        setSupplyItems({ ...supplyItems, saving: false,open_two:false });
        
        var d = response.data;

          if(d.data.item_category!=null){
              d.data.item_type= d.data.item_category.item_type
              d.data.name=d.data.item_category.name
          }else{
              d.data.item_category=null
          }
      
        // var itms = supplyItems.data;
        
        // itms.unshift(d.data);
        
        // setSupplyItems({...supplyItems,data: itms,open: false,});
        

      setItemCategoryId({value:0,error:""});
      setSupplierName({value:"",error:""});
      setSerialNumbers([]);
      setSerialNumber({value:"",error:""});
      setEndingSerialNumber({value:"",error:""});
      setStartingSerialNumber({value:"",error:""});
      setUids([]);
      setUid({value:"",error:""});

      get_supply_items(accountData.token);

      notify("success", response.data.message);

      })
      .catch(function (error) {
        setSupplyItems({ ...supplyItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });

  }

  ///////////////////////////////////

  const getStoks = (token) => {

    const stkInstance = axios.create(new AdminService().getHeaders(token));

    setStocks({ ...stocks, loading: true });

    console.log("getting stocks .....");

    stkInstance
      .get(new ReportingService().GET_ALL_STOCKS)
      .then(function (response) {
        setStocks({ ...stocks, loading: false });

        const d = response.data.data?.records;

        if (d.length == 0) {
          setStocks({ ...stocks, status: "There are no stocks available" });
        } else {
          var st = stocks.data;

          d.forEach((s, i) => {
            st.push(s);
          });

          setStocks({ ...stocks, data: st });
        }
      })
      .catch(function (error) {
        setStocks({ ...stocks, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStocks({ ...stocks, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const getAllItems = (token) => {
    const itemsInstance = axios.create(new AdminService().getHeaders(token));

    setAllItems({ ...allItems, loading: true });

    console.log("getting allItems .....");

    itemsInstance
      .get(new ReportingService().GET_ITEM_CATEGORIES)
      .then(function (response) {
        setAllItems({ ...allItems, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setAllItems({ ...allItems, status: "No items available" });
        } else {
            d.data.map((o)=>{
                if(o.parent_category!=null){
                    o.parent_category= o.parent_category.name
                    o.parent_category_id=o.parent_category.id
                }else{
                    o.parent_category_id=null
                }
            
            })
          setAllItems({
            ...allItems,
            data: d.data,
          });
        }
      })
      .catch(function (error) {
        setAllItems({ ...allItems, loading: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        setAllItems({ ...allItems, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


  //////////////////////////////////

  const createItem = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAllItems({ ...allItems, saving: true });

    let data={}

    if(parentCategory.value!=""){
        data={
            description: itemDescription.value,
            item_type: itemType.value,
            name: itemName.value,
            parent_category_id:parentCategory.value,
            out_of_stock_flag: outOfStockFlag.value
          }
    }else{
       data=data={
        description: itemDescription.value,
        item_type: itemType.value,
        name: itemName.value,
        out_of_stock_flag: outOfStockFlag.value
      } 
    }

    console.log("Creating item .....");

    createInstance
      .post(new ReportingService().CREATE_ITEM_CATEGORY, data)
      .then(function (response) {
        
        setAllItems({ ...allItems, saving: false });
        
        var d = response.data;

        if(d.data.parent_category!=null){
            d.data.parent_category= d.data.parent_category.name
            d.data.parent_category_id=d.data.parent_category.id
        }else{
            d.data.parent_category_id=null
        }

        var itms = allItems.data;
        
        itms.unshift(d.data);
        
        setAllItems({
          ...allItems,
          data: itms,
          open: false,
        });

        setName({ value: "", error: "" });
        setDescription({ value: "", error: "" });
        setType({ value: "", error: "" });
        setParentCategory({value: "",error:""});
        setOutOfStockFlag({value: "",error:""});

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setAllItems({ ...allItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////////////// get supplied item by category id //////////////


  const get_item_category=(id)=>{
    const itemsInstance = axios.create(new AdminService().getHeaders(accountData.token));

    setSupplyItems({ ...supplyItems, data:[],loading: true });

    console.log("getting items category .....");

    itemsInstance
      .get(new ReportingService().GET_ITEM_CATEGORY+id)
      .then(function (response) {
        setSupplyItems({ ...supplyItems, loading: false });

        const d = response.data;

        if (d.data.content.length == 0) {
          setSupplyItems({ ...supplyItems, status: "No supply items available" });
        } else {
            d.data.content.map((o)=>{
              o.supplier_name=o.supply.supplier_name;
              o.starting_serial_number=o.serial_number;
              o.ending_serial_number=o.serial_number;
              o.quantity=1;
              o.done_at=o.supply.done_at;

                if(o.item_category!=null){
                    o.item_type= o.item_category.item_type
                    o.name=o.item_category.name
                }else{
                    o.item_category=null
                }
            
            })
            setSupplyItems({
            ...supplyItems,
            data: d.data.content,
          });
        }
      })
      .catch(function (error) {
        setSupplyItems({ ...supplyItems, loading: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        setSupplyItems({ ...supplyItems, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });

  }

  /////////////////////////////////  end get supplied item by category id ///////////

  const [categoryDetails,setCategoryDetails]=useState({category_id:0,category_name:""});


  /////////////////////////////  request item in item category  //////////////////


  const [organizationId,setOrganizationId]=useState({value:0,error:""});
  const [quantityItem,setQuantityItem]=useState({value:0,error:""});
  const [requestItem,setRequestItem]=useState({open:false,loading:false});

  const request_item=()=>{

    if(quantityItem.value==0){
      setQuantityItem({value:0,error:"Enter valid quantity"});
    }else if(organizationId.value==0 || organizationId.value==""){
      setOrganizationId({value:0,error:"Please select organization"});
    }else{

    setRequestItem({...requestItem,loading:true});

    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    let data={
      item_category_id:categoryDetails.category_id,
      organization_id:organizationId.value,
      quantity: quantityItem.value
    }

    console.log("Rquesting item category ...");

    createInstance
      .post(new ReportingService().REQUEST_ITEM, data)
      .then(function (response) {
        
        setRequestItem({...requestItem,loading:false,open:false});

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setAllItems({ ...allItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
    }
  }



  ////////////// get organizations //////////////

  const [organizations,setOrganizations]=useState({
    loading: false,
    saving: false,
    status: "Loading all organization...",
    toggling: false,
    data: [],
  });

  const get_organization=(token)=>{
    const organizationInstance = axios.create(new AdminService().getHeaders(token));

    setOrganizations({...organizations, loading: true });

    console.log("getting all organizations ...");

    organizationInstance
      .get(new ReportingService().GET_CUSTOMER_BY_TYPE+"ORGANIZATION")
      .then(function (response) {
        setOrganizations({...organizations, loading: false });

        const d = response.data;

        if (d.data.content.length == 0) {
          setOrganizations({ ...organizations, status: "No supply items available" });
        } else {
          setOrganizations({
            ...organizations,
            data: d.data.content,
          });
        }
      })
      .catch(function (error) {
        setOrganizations({ ...organizations, loading: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        setOrganizations({...organizations, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);

      });
  }
  //////////// end get organizations /////////


  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Dialog aria-labelledby="simple-dialog-title" open={distribution.saving}>
        <DialogContent>
          <Box p={2} display="flex" alignItems="center">
            <CircularProgress color="primary" />
            <Box pl={2}>
              <Typography color="textSecondary">
                {distribution.status}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ///////////////////////////////////   create new item category //////////////// */}

      <Dialog
        open={allItems.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setAllItems({ ...allItems, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Create new item category"}
        </DialogTitle>
        <DialogContent>
        <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={itemName.value}
                  placeholder={translate("inventory.forms.hints.item_name")}
                  label={<Translate id="inventory.forms.labels.item_name" />}
                  fullWidth
                  onChange={onNameChange}
                  helperText={itemName.error}
                  error={itemName.error !== ""}
                />
              )}
            </Translate>
          </Box>  

          <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="number"
                  value={outOfStockFlag.value}
                  placeholder={"Out of stock flag"}
                  label={"Out of stock flag"}
                  fullWidth
                  onChange={(e)=>{
                    setOutOfStockFlag({value:e.target.value,error:""});
                  }}
                  helperText={outOfStockFlag.error}
                  error={outOfStockFlag.error !== ""}
                />
          </Box>


          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                itemType.error !== "" ||
                allItemTypes.status == "error" ||
                allItemTypes.status == "empty"
              }
              disabled={
                allItemTypes.status == "error" || allItemTypes.status == "empty"
              }
            >
              <InputLabel>
                <Translate id="inventory.forms.labels.item_type" />
              </InputLabel>
              <Select
                label={<Translate id="inventory.forms.labels.item_type" />}
                value={itemType.value}
                onChange={onTypeChange}
              >
                {allItemTypes.data?.map((tp, i) => (
                  <MenuItem value={tp}>{tp}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {allItemTypes.status == "error"
                  ? "Error loading item types, try reloading"
                  : allItemTypes.status == "empty"
                  ? "There are not item types available,create one first"
                  : itemType.error}
              </FormHelperText>
            </FormControl>
          </Box>
         
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                parentCategory.error !== "" ||
                allItems.status == "error" ||
                allItems.status == "empty"
              }
              disabled={
                allItems.status == "error" || allItems.status == "empty"
              }
            >
              <InputLabel>
                <Translate id="inventory.forms.labels.parent_category" />
              </InputLabel>
              <Select
                label={<Translate id="inventory.forms.labels.parent_category" />}
                value={parentCategory.value}
                onChange={onCategoryChange}
              >
                {allItems.data?.map((c, i) => (
                  <MenuItem value={c.id}>{c.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {allItems.status == "error"
                  ? "Error loading item category, try reloading"
                  : allItems.status == "empty"
                  ? "There are no item category available,create one first"
                  : parentCategory.error}
              </FormHelperText>
            </FormControl>
          </Box> 
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={itemDescription.value}
                  placeholder={translate("inventory.forms.hints.category_description")}
                  label={<Translate id="inventory.forms.labels.category_description" />}
                  fullWidth
                  onChange={onDescriptionChange}
                  helperText={itemDescription.error}
                  error={itemDescription.error !== ""}
                  multiline
                  rows={4}
                />
              )}
            </Translate>
          </Box>
          
              
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setAllItems({ ...allItems, open: false })}
          >
            <Translate id="commissions.forms.buttons.cancel" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={onCreateItemClick}
            disabled={allItems.saving}
          >
            {allItems.saving ? (
              <CircularProgress size={23} />
            ) : (
              <Translate id="commissions.forms.buttons.create" />
            )}
          </Button>
        </DialogActions>
      </Dialog>


       {/* ///////////////////////////////////  supply multiple items  //////////////// */}


       <Dialog
        open={supplyItems.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setSupplyItems({ ...supplyItems, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Record Supply Item(s)"}
        </DialogTitle>
        <DialogContent>
        <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={supplierName.value}
                  placeholder={"Supplier Name"}
                  label={"Supplier Name"}
                  fullWidth
                  onChange={(e)=>{
                      setSupplierName({value:e.target.value,error:""});
                  }}
                  helperText={supplierName.error}
                  error={supplierName.error !== ""}
                />

          </Box>


          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                allItems.error !== "" ||
                allItems.status == "error" ||
                allItems.status == "empty"
              }
              disabled={
                allItems.status == "error" || allItems.status == "empty"
              }
            >
              <InputLabel>
               <Typography>Item Category</Typography>
              </InputLabel>
              <Select
                label={"Category Item"}
                value={itemCategoryId.value}
                onChange={(e)=>{

                  if(e.target.value.value!=""){
                    setItemCategoryId({value:e.target.value,error:""});
                  }

                }}
              >
                {allItems.data?.map((tp, i) => (
                  <MenuItem value={tp.id}>{tp.name+" ("+tp.item_type+")"}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {allItems.status == "error"
                  ? "Error loading item types, try reloading"
                  : allItems.status == "empty"
                  ? "There are not item types available,create one first"
                  : allItems.error}
              </FormHelperText>
            </FormControl>
          </Box>



         
          <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="number"
                  value={quantity.value}
                  placeholder={"Quantity"}
                  label={"Quantity"}
                  fullWidth
                  onChange={(e)=>{
                    setQuantity({value:e.target.value,error:""});
                  }}
                  helperText={quantity.error}
                  error={quantity.error !== ""}
                />
          </Box>

<Grid container>
  <Grid item md={11}>
  <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={uid.value}
                  placeholder={"Unique Identifier"}
                  label={"Unique Identifier"}
                  fullWidth
                  onChange={(e)=>{
                    setUid({value:e.target.value,error:""});
                  }}
                  helperText={uid.error}
                  error={uid.error !== ""}
                />
          </Box>
    </Grid>
    <Grid item md={1}>
    <Box mt={2}>
      <IconButton color="secondary" aria-label="add indentifiers" component="span" 
      onClick={()=>{
        if(uid.value!=""){
          var d=uniqueIdentifiers;
          d.push(uid.value);
          setUniqueIdentifiers(d);
          setUid({value:"",error:""});
        }else{
          setUid({value:"",error:"Empty unique identifier detected!"});
        }
      }}
      >
          <Add/>
        </IconButton>
          </Box>
      </Grid>
  </Grid>

  <Box mt={2}>
    
  <List dense={true}>

   

    {uniqueIdentifiers.map((o,i)=><ListItem>
 <ListItemText
   primary={o}
 />
 <ListItemSecondaryAction>
   <IconButton edge="end" aria-label="delete" onClick={()=>{

   }}>
     <Delete />
   </IconButton>
 </ListItemSecondaryAction>
 <Divider/>
</ListItem>)}
             
            </List>
  
  </Box>

          
          
              
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setSupplyItems({ ...supplyItems, open: false })}
          >
            <Typography>Cancel</Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={()=>{
              supply_item();
            }}
            disabled={supplyItems.saving}
          >
            {supplyItems.saving ? (
              <CircularProgress size={23} />
            ) : (
             <Typography>Record Supply</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
       {/* //////////////////////  end supply ///////////////// */}
 

       {/* ///////////////////////////////////  supply multiple cards  //////////////// */}


       <Dialog
        open={supplyItems.open_two}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setSupplyItems({ ...supplyItems, open_two: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Record Supply Item(s)"}
        </DialogTitle>
        <DialogContent>
        <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={supplierName.value}
                  placeholder={"Supplier Name"}
                  label={"Supplier Name"}
                  fullWidth
                  onChange={(e)=>{
                    if(e.target.value!=""){
                      setSupplierName({value:e.target.value,error:""});
                    }
                    
                  }}
                  helperText={supplierName.error}
                  error={supplierName.error !== ""}
                />

          </Box>


          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                allItems.error !== "" ||
                allItems.status == "error" ||
                allItems.status == "empty"
              }
              disabled={
                allItems.status == "error" || allItems.status == "empty"
              }
            >
              <InputLabel>
               <Typography>Item Category</Typography>
              </InputLabel>
              <Select
                label={"Category Item"}
                value={itemCategoryId.value}
                onChange={(e)=>{

                  if(e.target.value.value!=""){
                    setItemCategoryId({value:e.target.value,error:""});
                  }

                }}
              >
                {allItems.data?.map((tp, i) => (
                  <MenuItem value={tp.id}>{tp.name+" ("+tp.item_type+")"}</MenuItem>
                ))}
              </Select>
              {/* <FormHelperText>
                {allItems.status == "error"
                  ? "Error loading item types, try reloading"
                  : allItems.status == "empty"
                  ? "There are not item types available,create one first"
                  : allItems.error}
              </FormHelperText> */}
            </FormControl>
          </Box>



         
          <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="number"
                  value={startingSerialNumber.value}
                  placeholder={"Starting Serial Number"}
                  label={"Starting Serial Number"}
                  fullWidth
                  onChange={(e)=>{
                    setStartingSerialNumber({value:e.target.value,error:""});
                  }}
                  helperText={startingSerialNumber.error}
                  error={startingSerialNumber.error !== ""}
                />
          </Box>

          <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="number"
                  value={endingSerialNumber.value}
                  placeholder={"Ending Serial Number"}
                  label={"Ending Serial Number"}
                  fullWidth
                  onChange={(e)=>{
                    setEndingSerialNumber({value:e.target.value,error:""});
                  }}
                  helperText={endingSerialNumber.error}
                  error={endingSerialNumber.error !== ""}
                />
          </Box>


<Grid container>
  <Grid item md={11}>
  <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={uid.value}
                  placeholder={"Unique Identifier"}
                  label={"Unique Identifier"}
                  fullWidth
                  onChange={(e)=>{
                    setUid({value:e.target.value,error:""});
                  }}
                  helperText={uid.error}
                  error={uid.error !== ""}
                />
          </Box>
    </Grid>
    <Grid item md={1}>
    <Box mt={2}>
      <IconButton color="secondary" aria-label="add indentifiers" component="span" 
      onClick={()=>{
        if(uid.value!=""){
          var d=uids;
          d.push(uid.value);
          setUids(d);
          setUid({value:"",error:""});
        }else{
          setUid({value:"",error:"Empty unique identifier detected!"});
        }
      }}
      >
          <Add/>
        </IconButton>
          </Box>
      </Grid>
  </Grid>





  <Box mt={2}>
    
  <List dense={true}>

    {uids.map((o,i)=><ListItem>
 <ListItemText
   primary={o}
 />
 <ListItemSecondaryAction>
   <IconButton edge="end" aria-label="delete" onClick={()=>{

   }}>
     <Delete />
   </IconButton>
 </ListItemSecondaryAction>
 <Divider/>
</ListItem>)}
             
            </List>
  
  </Box>





  <Grid container>
  <Grid item md={11}>
  <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={serialNumber.value}
                  placeholder={"Serial Number"}
                  label={"Serial Number"}
                  fullWidth
                  onChange={(e)=>{
                    setSerialNumber({value:e.target.value,error:""});
                  }}
                  helperText={serialNumber.error}
                  error={serialNumber.error !== ""}
                />
          </Box>
    </Grid>
    <Grid item md={1}>
    <Box mt={2}>
      <IconButton color="secondary" aria-label="add indentifiers" component="span" 
      onClick={()=>{
        if(serialNumber.value!=""){
          var d=serialNumbers;
          d.push(serialNumber.value);
          setSerialNumbers(d);
          setSerialNumber({value:"",error:""});
        }else{
          setUid({value:"",error:"Empty unique identifier detected!"});
        }
      }}
      >
          <Add/>
        </IconButton>
          </Box>
      </Grid>
  </Grid>


  <Box mt={2}>
    
    <List dense={true}>
  
      {serialNumbers.map((o,i)=><ListItem>
   <ListItemText
     primary={o}
   />
   <ListItemSecondaryAction>
     <IconButton edge="end" aria-label="delete" onClick={()=>{
  
     }}>
       <Delete />
     </IconButton>
   </ListItemSecondaryAction>
   <Divider/>
  </ListItem>)}
               
              </List>
    
    </Box>
  
          
              
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setSupplyItems({ ...supplyItems, open_two: false })}
          >
            <Typography>Cancel</Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={()=>{
              supply_item_card();              
            }}
            disabled={supplyItems.saving}
          >
            {supplyItems.saving ? (
              <CircularProgress size={23} />
            ) : (
             <Typography>Record Supply Cards</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
       {/* //////////////////////  end supply ///////////////// */}




       
       {/* ////////////////////////  request item /////////////// */}

       <Dialog
        open={requestItem.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setRequestItem({ ...requestItem, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Request Item"}
        </DialogTitle>
        <DialogContent>


        <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              // error={
              //   organizations.error !== "" ||
              //   organizations.status == "error" ||
              //   organizations.status == "empty"
              // }
              disabled={
                organizations.status == "error" || organizations.status == "empty"
              }
            >
              <InputLabel>
               <Typography>Organization</Typography>
              </InputLabel>
              <Select
                label={"Category Item"}
                value={organizationId.value}
                onChange={(e)=>{

                  if(e.target.value.value!=""){
                    setOrganizationId({value:e.target.value,error:""});
                  }

                }}
              >
                {organizations.data?.map((o, i) => (
                  <MenuItem value={o.id}>{o.full_names}</MenuItem>
                ))}
              </Select>
              {/* <FormHelperText>
                {allItems.status == "error"
                  ? "Error loading item types, try reloading"
                  : allItems.status == "empty"
                  ? "There are not item types available,create one first"
                  : allItems.error}
              </FormHelperText> */}
            </FormControl>
          </Box>


   
        <Box mt={2}>
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={quantityItem.value}
                  placeholder={"Quantity"}
                  label={"Quantity"}
                  fullWidth
                  onChange={(e)=>{
                      setQuantityItem({value:e.target.value,error:""});
                  }}
                  helperText={quantityItem.error}
                  error={quantityItem.error !== ""}
                />

          </Box>

              
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setRequestItem({ ...requestItem, open: false })}
          >
            <Typography>Cancel</Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={()=>{
              request_item();
            }}
            disabled={requestItem.loading}
          >
            {requestItem.loading ? (
              <CircularProgress size={23} />
            ) : (
             <Typography>Request Item</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>

       {/* ////////////////////////// end requets item ////////////// */}
 

      <Box display="flex">
        <Box mr={2}>
          {" "}
          <Store color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Inventory</b>
        </Typography>
{/* 
        {!matches ? (
          <>
            <IconButton onClick={(e) => setMenuOpen(e.currentTarget)}>
              <MoreVert />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={menuOpen}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen != null}
              onClose={() => setMenuOpen(null)}
            >
             

              <MenuItem
                onClick={() => { setSupplyItems({ ...supplyItems, open: true })}}
              >
                Record Supply Item
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Box display="flex">
          
            <Box ml={2} />
            <Button
              className={classes.btn}
              color="primary"
              variant="contained"
              size="medium"
              startIcon={<Add />}
              disableElevation
              onClick={() =>{ setSupplyItems({ ...supplyItems, open: true })}}
            >
              Record Supply Item
            </Button>
          </Box>
        )} */}

        
      </Box>
      <Box mt={3} />
      <Grid container spacing={2}>

        <Grid item xs={12} md={5}>
          <Box
            width={1}
            mb={2}
            display="flex"
            justifyContent="space-between"
            height="40px"
          >
            <>
              <ButtonGroup color="primary" variant="outlined">
                <Button>{anchorEl.menu_name}</Button>
                <Button
                  onClick={(e) =>
                    setAnchorEl({ ...anchorEl, anchor: e.currentTarget })
                  }
                >
                  <ArrowDropDown />
                </Button>
              </ButtonGroup>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl.anchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                open={anchorEl.anchor != null}
                onClose={() => setAnchorEl({ ...anchorEl, anchor: null })}
              >
                <MenuItem
                  selected={anchorEl.menu == 0}
                  onClick={() => {
                    setAnchorEl({ ...anchorEl, menu: 0, anchor: null,menu_name:"STOCK IN"});
                    setSupplyItems({ ...supplyItems, open: true })
                  }}
                >
                  Stock in items
                </MenuItem>
                <MenuItem
                  selected={anchorEl.menu == 1}
                  onClick={() => {
                    setAnchorEl({ ...anchorEl, menu: 1, anchor: null,menu_name:"STOCK IN" });
                    setSupplyItems({ ...supplyItems, open_two: true })
                  }}
                >
                  Stock in cards
                </MenuItem>
                <MenuItem
                  selected={anchorEl.menu == 2}
                  onClick={() => {
                    setAnchorEl({ ...anchorEl, menu: 2, anchor: null,menu_name:"STOCK OUT" });
                  }}
                >
                  Stock out
                </MenuItem>
              </Menu>
            </>
            {searchMode && (
              <Box ml={1} alignSelf="flex-end">
                <TextField
                  size="small"
                  color="primary"
                  placeholder="Search stock"
                  fullWidth
                />
              </Box>
            )}
            <Box>
              <IconButton
                color="primary"
                onClick={() => setSearchMode(!searchMode)}
              >
                <Search />
              </IconButton>
            </Box>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <CardActionArea
                  className={classes.action}
                  onClick={() => {

                    setAction("create"); 
                    setAllItems({ ...allItems, open: true })


                  }}
                >
                  <Box
                    height="70px"
                    width={1}
                    display="flex"
                    alignItems="center"
                    border={1}
                    borderStyle="dotted"
                    borderRadius="borderRadius"
                    borderColor="grey.300"
                    className={classes.btn2}
                  >
                    <Box mr={1} ml={1}>
                      <Add fontSize="default" />
                    </Box>
                    <Typography color="inherit">New Category</Typography>
                  </Box>
                </CardActionArea>
              </Box>
            </Grid>

            {allItems?.data?.length == 0 && !allItems.loading && (
              <Box
                p={2}
                mt={3}
                height={1}
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
              >
                <Box mt={2}>
                  <img src={Empty} alt="Empty data" height={160} />
                </Box>
                <Typography color="textSecondary">
                  There are no stocks initialized, create one first
                </Typography>
              </Box>
            )}

            {allItems.loading
              ? [1, 2, 3, 4, 5].map((o, i) => (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      borderRadius={15}
                      width={1}
                    >
                      <Skeleton
                        variant="rect"
                        height={70}
                        width={"100%"}
                        style={{ borderRadius: 15 }}
                      />
                    </Box>
                  </Grid>
                ))
              : allItems?.data?.map((stk, i) => (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDirection="column"
                    >
                      <CardActionArea
                        className={classes.action}
                        onClick={() => {
                          // when click on specific stock item category 
                          setCategoryDetails({category_id:stk.id,category_name:stk.name});
                          get_item_category(stk.id);
                        }}
                      >
                        <Paper
                          className={classes.card}
                          elevation={0}
                          // style={{
                          //   background:
                          //     stockItems?.index == i &&
                          //     theme.palette.type == "dark"
                          //       ? "#757575"
                          //       : stockItems?.index == i &&
                          //         theme.palette.type != "dark" &&
                          //         "#e0e0e0",
                          // }}
                        >
                          <Box
                            height="60px"
                            width={1}
                            display="flex"
                            alignItems="center"
                            border={0}
                            className={classes.action}
                            borderColor="primary.main"
                          >
                            <Box display="flex" width={1}>
                              <Box mr={1} ml={1}>
                                <Folder fontSize="default" />
                              </Box>

                              <Box display="flex" flexDirection="column">
                                <Typography color="inherit" noWrap>
                                  {stk.name}
                                </Typography>

                                <Typography color="inherit" variant="body2" noWrap>
                                  {stk.item_type}
                                </Typography>

                                <Typography
                                  color="textSecondary"
                                  variant="caption"
                                  noWrap
                                >
                                  {stk.description}
                                </Typography>
                              </Box>
                            </Box>

                            

                            {/* <IconButton color="primary" aria-label="menu" component="span">
                              <MenuOpen />
                            </IconButton> */}

                            <Badge
                              badgeContent={stk.out_of_stock_flag}
                              color="primary"
                              max={999}
                              invisible={stk.out_of_stock_flag == 0}
                            >
                              <Box m={1} height={30}></Box>
                            </Badge>

                          </Box>
                        </Paper>
                      </CardActionArea>
                    </Box>
                  </Grid>
                ))}
          </Grid>
          <Box width={1} mt={2} display="flex" justifyContent="center">
            <Pagination disabled count={10} color="primary" size="medium" />
          </Box>
        </Grid>

        
          <Grid item xs={12} md={7}>
            <Box width={1} mb={2} display="flex">
              {categoryDetails.category_id==0?<Typography style={{flexGrow: 1,}} variant="h6">All Supplier items</Typography>:<Typography style={{flexGrow: 1,}} variant="h6">{categoryDetails.category_name}</Typography>}
              {categoryDetails.category_id!=0&&<Button color="primary" variant="outlined" onClick={()=>{
                setRequestItem({...requestItem,open:true});
              }}>Request Item</Button>}
            </Box>
            {supplyItems.loading && <LinearProgress />}
            <MUIDataTable
              title={"List of all supplied items"}
              data={supplyItems.data}
              columns={columns}
              options={options}
            />
          </Grid>
      </Grid>
    </div>
  );
}

export default withLocalize(Inventory);
